import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  ref
} from 'vue'
import type { PropType } from 'vue'
import { useTimeoutFn } from '@vueuse/core'
import { emitter, emitOpenAccountDialog } from '@/plugins/emitter'

type YagiOptions = {
  dialogEnabled?: boolean
  rubyEnabled?: boolean
  messageEnabled?: boolean
  fixedMessage?: string
}

type YagiMessagePayload = {
  text?: unknown
  durationMs?: unknown
}

type YagiClient = {
  profile: {
    name: string
    color: string
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'YourYagi',
  props: {
  yagiOptions: {
    type: Object as PropType<YagiOptions>
  }
},
  setup(__props) {

const props = __props;



const yagi = (getCurrentInstance()!.proxy as unknown as { $yagi: YagiClient })
  .$yagi

const message = ref('')
const hideDelayMs = ref(3000)
const { start: startHideMessage, stop: stopHideMessage } = useTimeoutFn(
  () => {
    message.value = ''
  },
  hideDelayMs,
  { immediate: false }
)

function isOptionEnabled<T>(name: keyof YagiOptions, defaultValue: T): T {
  const options = props.yagiOptions
  if (options && Object.prototype.hasOwnProperty.call(options, name)) {
    return options[name] as T
  }
  return defaultValue
}

const dialogEnabled = computed(() => isOptionEnabled('dialogEnabled', true))
const rubyEnabled = computed(() => isOptionEnabled('rubyEnabled', true))
const messageEnabled = computed(() => isOptionEnabled('messageEnabled', false))
const fixedMessage = computed(() => isOptionEnabled('fixedMessage', ''))

function openDialog() {
  if (dialogEnabled.value) {
    emitOpenAccountDialog()
  }
}

function showMessage(nextMessage: unknown, durationMs?: unknown) {
  if (!messageEnabled.value) return
  message.value = String(nextMessage ?? '')
  hideDelayMs.value =
    typeof durationMs === 'number' && Number.isFinite(durationMs)
      ? durationMs
      : 3000
  stopHideMessage()
  startHideMessage()
}

function onYagiMessage(payload: unknown) {
  const body = payload as YagiMessagePayload | undefined
  showMessage(body?.text, body?.durationMs)
}

function networkChangeMessage(online: unknown) {
  if (online) {
    showMessage('つながった')
  } else {
    showMessage('オフラインになった')
  }
}

onBeforeMount(() => {
  emitter.on('yagi-message', onYagiMessage)
  emitter.on('network-changed', networkChangeMessage)
})

onBeforeUnmount(() => {
  emitter.off('yagi-message', onYagiMessage)
  emitter.off('network-changed', networkChangeMessage)
})

return { __sfc: true,props, yagi, message, hideDelayMs, startHideMessage, stopHideMessage, isOptionEnabled, dialogEnabled, rubyEnabled, messageEnabled, fixedMessage, openDialog, showMessage, onYagiMessage, networkChangeMessage }
}

})